import React from 'react';
import { DrawerBody, DrawerFooter } from '@fiverr-private/overlay';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { AppI18n } from '../../i18n';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { briefCreationClickAction } from '../../monitoring/bqEvents';
import { Step } from '../../constants';
import { ErrorIcon } from './ErrorIcon';

export const ErrorStep = () => {
  const { currentStep, setStep, contextId, source, regenerateContextId, variant, parentElement } =
    useBriefCreationContext();

  const goBack = () => {
    briefCreationClickAction({
      step: currentStep,
      action: 'go_back',
      briefContextId: contextId,
      eventSource: source || '',
      variant,
      parentElement,
    });
    setStep(Step.Creation);

    // force re-generation of new context ID
    regenerateContextId();
  };

  return (
    <Stack direction="column" height="100%">
      <DrawerBody flexGrow={1}>
        <Stack direction="column" height="100%" width="100%" alignItems="center" justifyContent="center" gap="8">
          <ErrorIcon />
          <Stack direction="column" alignItems="center">
            <Text size="b_lg" fontWeight="bold">
              <AppI18n k="error_step.title" />
            </Text>
            <Text size="b_sm" color="bodySecondary" textAlign="center">
              <AppI18n k="error_step.description" />
            </Text>
          </Stack>
        </Stack>
      </DrawerBody>
      <DrawerFooter>
        <Stack direction="row" justifyContent="flexEnd">
          <Button onClick={goBack}>
            <AppI18n k="back" />
          </Button>
        </Stack>
      </DrawerFooter>
    </Stack>
  );
};
